// extracted by mini-css-extract-plugin
export var fontFamilyHeader = "footer-module--font-family-header--15b5J";
export var btn = "footer-module--btn--4m5TK";
export var contentContainer = "footer-module--content-container--3ysJ3";
export var Footer = "footer-module--Footer--3Smne";